/* eslint-disable no-useless-escape */
import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import _ from "lodash";

// This sets the mock adapter on the default instance
var mock = new MockAdapter(axios, {
  onNoMatch: "passthrough",
  //delayResponse: 1000,
});

import CONTENTS from "./mock-data/contents.json";
import ACADEMIES from "./mock-data/academies.json";
import ACADEMY_SKILL_PATHS from "./mock-data/academy-skill-paths.json";
import SKILL_PATH_LEVELS from "./mock-data/skill-path-levels.json";
import CONTENT_SKILL_PATH_MAPPING from "./mock-data/content-skill-path-mapping.json";
import SKILL_PATHS from "./mock-data/skill-paths.json";
import HEROES from "./mock-data/heroes.json";

function getIdsFromUrl(url) {
  const ids = url.match(getAllGuidsPattern);
  return ids;
}

const matchGuidPattern =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";
const getAllGuidsPattern =
  /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/gi;

export function startMockServer() {
  mock.onGet("/heroes").reply(200, HEROES);

  mock.onGet("/contents").reply((config) => {
    return [200, CONTENTS];
  });

  mock.onGet("/skill-path-levels").reply(200, SKILL_PATH_LEVELS);

  mock
    .onGet(new RegExp(`\/contents\/${matchGuidPattern}`, "ig"))
    .reply((config) => {
      let ids = getIdsFromUrl(config.url);
      let response = _.find(CONTENTS, (item) => item.id == ids[0]);
      return [200, response];
    });

  mock.onGet("/academies").reply((config) => {
    let response = ACADEMIES.map((a) => ({
      ...a,
      progress: {
        total: ACADEMY_SKILL_PATHS.filter((b) => b.AcademyId == a.Id).length,
        completed: 0,
      },
    }));
    return [200, response];
  });

  mock.onGet("/skill-paths").reply((config) => {
    let response = SKILL_PATHS.map((a) => ({
      ...a,
      academy: ACADEMIES.find(
        (c) =>
          c.Id ==
          ACADEMY_SKILL_PATHS.find((b) => b.Id == a.SkillPathId)?.AcademyId
      ),
    }));
    return [200, response];
  });

  mock
    .onGet("/skill-paths/b8058eff-3019-4a6d-9fb7-008eeeeb646b/contents")
    .reply((config) => {
      let ids = getIdsFromUrl(config.url);
      let contentIds = CONTENT_SKILL_PATH_MAPPING.filter(
        (a) => a.skillPathId == ids[0]
      ).map((b) => b.contentId);
      let response = _.filter(
        CONTENTS,
        (item) => contentIds.indexOf(item.id) >= 0
      );

      return [200, response];
    });

  mock
    .onGet(new RegExp(`^\/skill-paths\/${matchGuidPattern}\/contents$`, "ig"))
    .reply((config) => {
      let ids = getIdsFromUrl(config.url);
      let contentIds = CONTENT_SKILL_PATH_MAPPING.filter(
        (a) => a.skillPathId == ids[0]
      ).map((b) => b.contentId);
      let response = _.filter(
        CONTENTS,
        (item) => contentIds.indexOf(item.id) >= 0
      );

      return [200, response];
    });

  mock
    .onGet(new RegExp(`^\/academies\/${matchGuidPattern}$`, "ig"))
    .reply((config) => {
      let ids = getIdsFromUrl(config.url);
      let response = _.find(ACADEMIES, (item) => item.id == ids[0]);
      response.progress = {
        completed: 0,
        total: 50,
      };
      return [200, response];
    });

  mock
    .onGet(new RegExp(`^\/academies\/${matchGuidPattern}\/courses$`, "ig"))
    .reply((config) => {
      //let ids = getIdsFromUrl(config.url);
      let response = CONTENTS;
      return [200, response];
    });

  function getAcademyBySkillPathId(skillPathId) {
    return ACADEMIES.find(
      (a) =>
        a.id ==
        ACADEMY_SKILL_PATHS.find((asp) => asp.SkillPathId == skillPathId)?.AcademyId
    );
  }

  function getSkillPathLevelById(skillPathLevelId) {
    return SKILL_PATH_LEVELS.find((spl) => spl.id == skillPathLevelId);
  }

  // function getAcademyById(academyId) {
  //   return ACADEMIES.find((a) => a.Id == academyId);
  // }

  mock
    .onGet(new RegExp(`^\/academies\/${matchGuidPattern}\/skill-paths$`, "ig"))
    .reply((config) => {
      let ids = getIdsFromUrl(config.url);
      let response = SKILL_PATHS.map((a) => ({
        ...a,
        academy: getAcademyBySkillPathId(a.id),
        skillPathLevel: getSkillPathLevelById(a.skillPathLevelId),
        stats: {
          progress: Math.round(Math.random() * 100),
          total: 100,
        },
      })).filter((a) => a.academy.id == ids[0]);
      return [200, response];
    });

  mock.onPost("/auth/docebo").reply((config) => {
    //let ids = getIdsFromUrl(config.url);
    let token = localStorage.getItem("docebo_token");
    let response = {
      code: "372DZAY4N6",
      token,
      domain: "eyskillsfoundrysandbox.docebosaas.com",
    };
    return [200, response];
  });
  // let response = SKILL_PATHS.map((a) => ({
  //   ...a,
  //   academy: getAcademyBySkillPathId(a.skillPathId),
  //   stats: {
  //     progress: Math.round(Math.random() * 100),
  //     total: 100,
  //   },
  // })).filter((a) => a.academy.id == '4f1d3149-546b-4443-a5c6-87af8cdbd369');
}
